import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const listByEquipmentKey = (equipmentId) => ['listByEquipment', equipmentId];
export const listByEquipmentFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL}list-by-equipment/${queryKey[1]}/0`);

export const useListByEquipmentQuery = ({ equipmentId, isByEquipment, installationPointId }) => {
  return useQuery({
    queryKey: listByEquipmentKey(equipmentId),
    queryFn: listByEquipmentFn,
    enabled: !!equipmentId,
    select: ({ data }) =>
      isByEquipment
        ? data?.list || []
        : data?.list?.filter((item) => +item.installation_point_id === +installationPointId) || [],
  });
};
